// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.minimized-modal[data-v-d158ba9c] {\n  position: fixed;\n  width: 100svw;\n  height: 100svh;\n  z-index: 30;\n  gap: 8px;\n\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: flex-end;\n  align-content: flex-end;\n\n  padding: 12.5px 32.5px;\n\n  pointer-events: none;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
